import React from 'react';
import './Button.scss';
import { ColourStyleEnum, FontStyleEnum } from '../models/api';
import { ReactComponent as ArrowIcon } from '../assets/arrow_forward_large.svg';

type EventStyleEditorProps = {
  fontStyleEnum: FontStyleEnum;
  setFontStyleEnum: (styleOption: FontStyleEnum) => void;
  colourStyleEnum: ColourStyleEnum;
  setColourStyleEnum: (colourPalette: ColourStyleEnum) => void;
  isCreation: boolean;
};
const EventStyleEditor: React.FC<EventStyleEditorProps> = ({
  fontStyleEnum,
  setFontStyleEnum,
  colourStyleEnum,
  setColourStyleEnum,
  isCreation
}) => {
  return (
    <>
      <label className="title" htmlFor="typeStyle">
        Fonts
      </label>
      <span>Choose a type style for your event.</span>
      <div className="radio-group">
        <label
          className={`radio-option ${fontStyleEnum === FontStyleEnum.Classic ? 'radio-option__selected' : ''}`}
        >
          <input
            type="radio"
            name="typeStyle"
            value={FontStyleEnum.Classic}
            checked={fontStyleEnum === FontStyleEnum.Classic}
            onChange={(e) => setFontStyleEnum(e.target.value as FontStyleEnum)}
          />
          <span className="radio-label radio-label__classic">
            Classic
            <span className="description">Classic body copy example</span>
          </span>
        </label>
        <label
          className={`radio-option ${fontStyleEnum === FontStyleEnum.Modern ? 'radio-option__selected' : ''}`}
        >
          <input
            type="radio"
            name="typeStyle"
            value={FontStyleEnum.Modern}
            checked={fontStyleEnum === FontStyleEnum.Modern}
            onChange={(e) => setFontStyleEnum(e.target.value as FontStyleEnum)}
          />
          <span className="radio-label radio-label__modern">
            Modern
            <span className="description">Modern body copy example</span>
          </span>
        </label>
      </div>
      <label className="title" htmlFor="colourPalette">
        Colour
      </label>
      <span>Choose a colour palette for your event.</span>

      <div className="radio-group radio-group__complex">
        <label
          className={`radio-option ${colourStyleEnum === ColourStyleEnum.Purple ? 'radio-option__selected' : ''}`}
        >
          <input
            type="radio"
            name="colourStlyle"
            value={ColourStyleEnum.Purple}
            checked={colourStyleEnum === ColourStyleEnum.Purple}
            onChange={(e) =>
              setColourStyleEnum(e.target.value as ColourStyleEnum)
            }
          />
          <div className="radio-label">
            <div className="radio-label__preview radio-label__preview__purple">
              <div className="button-container">
                <button type="button" className="button-preview-primary">
                  Button
                </button>
                <button type="button" className="button-preview-secondary">
                  <ArrowIcon />
                </button>
              </div>
              <span className="description">Body copy example</span>
            </div>
            <span className="title">Purple</span>
          </div>
        </label>
        <label
          className={`radio-option ${colourStyleEnum === ColourStyleEnum.Blue ? 'radio-option__selected' : ''}`}
        >
          <input
            type="radio"
            name="colourStlyle"
            value={ColourStyleEnum.Blue}
            checked={colourStyleEnum === ColourStyleEnum.Blue}
            onChange={(e) =>
              setColourStyleEnum(e.target.value as ColourStyleEnum)
            }
          />
          <div className="radio-label">
            <div className="radio-label__preview radio-label__preview__blue">
              <div className="button-container">
                <button type="button" className="button-preview-primary">
                  Button
                </button>
                <button type="button" className="button-preview-secondary">
                  <ArrowIcon />
                </button>
              </div>
              <span className="description">Body copy example</span>
            </div>
            <span className="title">Blue</span>
          </div>
        </label>
        <label
          className={`radio-option ${colourStyleEnum === ColourStyleEnum.Green ? 'radio-option__selected' : ''}`}
        >
          <input
            type="radio"
            name="colourStlyle"
            value={ColourStyleEnum.Green}
            checked={colourStyleEnum === ColourStyleEnum.Green}
            onChange={(e) =>
              setColourStyleEnum(e.target.value as ColourStyleEnum)
            }
          />
          <div className="radio-label">
            <div className="radio-label__preview radio-label__preview__green">
              <div className="button-container">
                <button type="button" className="button-preview-primary">
                  Button
                </button>
                <button type="button" className="button-preview-secondary">
                  <ArrowIcon />
                </button>
              </div>
              <span className="description">Body copy example</span>
            </div>
            <span className="title">Green</span>
          </div>
        </label>
      </div>

      {isCreation && (
        <p>You&apos;ll be able to make changes to your theme later.</p>
      )}
    </>
  );
};

export default EventStyleEditor;
